interface EnvironmentConfig {
  websocket: {
    proxy: string;
  };
}

const getEnvVar = (key: string, defaultValue: string = ''): string => {
  const value = process.env[key];
  if (!value && !defaultValue) {
    console.warn(`Missing environment variable: ${key}`);
  }
  return value || defaultValue;
};

export const environment: EnvironmentConfig = {
  websocket: {
    proxy: getEnvVar('REACT_APP_WEBSOCKET_PROXY', 'wss://wsproxy.quizriot.live'),
  },
};

export default environment;
